import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dynamicDecimal',
    standalone: false
})
export class DynamicDecimalPipe implements PipeTransform {
    transform(value: string, isDoublePill: boolean = true): string {
        if (!value) {
            return '';
        }

        // Convert ',' to '.' for calculations
        value = value.split('.').join(''); //7.567.789 , 7567789
        let convertedValue = parseFloat(value.replace(',', '.'));
        if (isNaN(convertedValue)) {
            return value; // Return the original value if it's not a valid number
        }

        if (isDoublePill) {
            return this.formatValueForDoubleSizePill(convertedValue);
        } else {
            return this.formatValueForSingleSizePill(convertedValue);
        }

    }

    private formatValueForDoubleSizePill(convertedValue: number): string {
        let formattedValue: string;
        const absValue = Math.abs(convertedValue);
        const digitsBeforeDecimal = Math.floor(absValue).toString().length;

        if (digitsBeforeDecimal === 1) {
            formattedValue = convertedValue.toFixed(3); // 3 decimals
        } else if (digitsBeforeDecimal === 2) {
            formattedValue = convertedValue.toFixed(2); // 2 decimals
        } else if (digitsBeforeDecimal === 3) {
            formattedValue = convertedValue.toFixed(1); // 1 decimal
        } else if (digitsBeforeDecimal === 4) {
            formattedValue = Math.round(convertedValue).toString(); // no decimals
        } else {
            formattedValue = convertedValue.toExponential(2); // scientific notation
        }

        return formattedValue.replace('.', ',');
    }

    private formatValueForSingleSizePill(convertedValue: number): string {
        let formattedValue: string;
        const absValue = Math.abs(convertedValue);
        const digitsBeforeDecimal = Math.floor(absValue).toString().length;

        if (digitsBeforeDecimal === 1 || digitsBeforeDecimal === 2) {
            formattedValue = convertedValue.toFixed(3); // 3 decimals
        } else if (digitsBeforeDecimal === 3) {
            formattedValue = convertedValue.toFixed(2); // 2 decimals
        } else if (digitsBeforeDecimal === 4) {
            formattedValue = convertedValue.toFixed(1); // 1 decimal
        } else if (digitsBeforeDecimal === 5 || digitsBeforeDecimal === 6) {
            formattedValue = Math.round(convertedValue).toString(); // no decimals
            return formattedValue = ((parseInt(formattedValue)) / 1000).toString(); // Need 1000 separator in 6 digit fox example 123456 should be displayed as 123.456
        } else {
            formattedValue = convertedValue.toExponential(2); // scientific notation
        }

        return formattedValue.replace('.', ',');
    }
}
